/*
 * @Author: benaozhi
 * @Date: 2020-07-19 19:25:44
 * @Description: 响应拦截器
 */
import config from '@/config'
import router from '@/render/router'
import element from '@/render/plugins/element'
import { clearLoginStatus } from '@/render/utils'
export const registerResponseInterceptors = axiosInstance => {
  axiosInstance.interceptors.response.use(validateCode)
}

/**
 * 验证响应数据的 code 是否正确
 */
function validateCode(response) {
  const res = response.data
  if (!res) {
    throw new Error(`请求失败`)
  }

  const code = res[config.SERVICES.RESPONSE_CODE_FILED]
  const { RESPONSE_CODE } = config.SERVICES
  if (code === RESPONSE_CODE.UNAUTHORIZED) {
    // token 过期或未登录
    // 当 UNAUTHORIZED_REDIRECT_PATH 有设置时进行自动跳转到登录页
    if (config.SERVICES.UNAUTHORIZED_REDIRECT_PATH) {
      element.Message({
        message: res[config.SERVICES.RESPONSE_MESSAGE_FILED],
        type: 'error',
        duration: 5000
      })
      clearLoginStatus()
      setTimeout(() => {
        router.replace({ path: config.SERVICES.UNAUTHORIZED_REDIRECT_PATH })
      }, 5000)
    }
    // 抛出异常中断外部后续逻辑
    throw new Error(res[config.SERVICES.RESPONSE_MESSAGE_FILED])
  } else if (code === RESPONSE_CODE.ERROR) {
    console.log('====res', res)
    element.Message({
      message: res[config.SERVICES.RESPONSE_DATA_FILED],
      type: 'error',
      duration: 5000,
      offset: 80
    })
    throw new Error(res[config.SERVICES.RESPONSE_DATA_FILED])
  } else {
    // 其他code，包括 RESPONSE_CODE.OK 在内全部放心
    // 如果有其它业务相关异常 CODE，请在外部处理
    return res
  }
}
